// Brand constants and shared data
export const BRAND = {
  name: "Stars of Autism",
  tagline: "Different, not less.",
  location: "Marion, Arkansas",
  director: "Chatoria Franklin",
  email: "contact@starsofautism.org",
};

export const COLORS = {
  blue: "#2196F3",
  red: "#E53935",
  yellow: "#FFB300",
  green: "#4CAF50",
  cream: "#FDFBF7",
  sand: "#F4F1EA",
  ink: "#1F2937",
};

// Local assets cropped from user-provided photos (see /app/frontend/public/images)
export const ASSETS = {
  logo: "/images/logo.jpg",                // Clean standalone Stars of Autism star logo
  chatoria: "/images/chatoria.jpg",        // Chatoria Franklin & her daughter
  qr: "/images/qr.jpg",                    // Cash App donation QR
  pavilion: "/images/pavilion.jpg",        // Outdoor pavilion community gathering
};

export const TIERS = [
  {
    key: "blue",
    name: "Blue Puzzle Piece",
    amount: 250,
    color: "#2196F3",
    bgTint: "rgba(33,150,243,0.06)",
    quote: "Autism is as much a part of humanity as is the capacity to dream.",
    author: "Kathleen Seidel",
  },
  {
    key: "red",
    name: "Red Puzzle Piece",
    amount: 150,
    color: "#E53935",
    bgTint: "rgba(229,57,53,0.06)",
    quote: "I am equal, loved, unique, purposed and worthy just because I am me.",
    author: "Kris McElroy",
  },
  {
    key: "yellow",
    name: "Yellow Puzzle Piece",
    amount: 75,
    color: "#FFB300",
    bgTint: "rgba(255,179,0,0.08)",
    quote: "Behavior is communication. Change the environment and behaviors will change.",
    author: "Lana David",
  },
  {
    key: "green",
    name: "Green Puzzle Piece",
    amount: 50,
    color: "#4CAF50",
    bgTint: "rgba(76,175,80,0.06)",
    quote: "How do I know how beautiful life is? I love someone with Autism.",
    author: "Unknown",
  },
];

export const FAQ = [
  {
    q: "What is the goal of the new facility?",
    a: "We are working to establish a permanent, brick-and-mortar hub in Marion, Arkansas — a place where individuals with Autism and their families can access vital resources and support outside of the school system.",
  },
  {
    q: "What will the event hall be used for?",
    a: "An inclusive, sensory-friendly space dedicated to hosting parties and community events designed specifically for children with Autism — so every child can celebrate and just be themselves.",
  },
  {
    q: "How can I contribute?",
    a: "Scan the Cash App QR code on our Donate page, choose a Partnership Tier, or reach out directly to our director Chatoria Franklin through the contact form. Every piece of the puzzle matters.",
  },
  {
    q: "Do you offer support outside of Marion?",
    a: "Our community is rooted in Marion and Crittenden County, but our resources, blog, and online forums are open to families everywhere.",
  },
  {
    q: "How can my business or church partner with you?",
    a: "We welcome partnerships at every level. Select a Puzzle Piece tier on the Donate page and we will follow up with personalized partnership benefits.",
  },
];
